<ng-container *ngIf="ajaxTokenizerUrl">
    <form name="tokenform" id="tokenform">
        <iframe id="tokenFrame" name="tokenFrame" [src]="ajaxTokenizerUrl | safe:'resourceUrl'" frameborder="0"
                scrolling="no" height="175" (load)="onLoadIFrame()"></iframe>
    </form>

    <div class="error" *ngIf="paymentProviderState === PaymentProviderStateEnum.Error">
        <p>{{!fiservEvent ? ('errors.10022' | translate) : fiservEvent.validationError}}</p>
    </div>
</ng-container>